<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero">
        <template #play>
          <AtomButton
            v-if="club.youtubeIframe"
            class="md:!hidden !absolute top-0 right-0 self-end btn-icon btn-lg btn-white"
            @click="modal = 'video'"
          >
            <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0.5 2.00161C0.5 0.823454 1.79592 0.105187 2.795 0.729608L9.689 5.03836C10.629 5.62586 10.629 6.99485 9.689 7.58235L2.795 11.8911C1.79592 12.5155 0.5 11.7973 0.5 10.6191V2.00161ZM2.265 1.57761C1.93198 1.36947 1.5 1.60889 1.5 2.00161V10.6191C1.5 11.0118 1.93198 11.2512 2.265 11.0431L9.159 6.73435C9.47234 6.53852 9.47234 6.08219 9.159 5.88636L2.265 1.57761Z"
                fill="white"
              />
            </svg>
          </AtomButton>
        </template>
        <template v-if="promo && !!promo.showLink" #footer>
          <div class="grid md:grid-cols-12 pt-4 md:pt-5">
            <div class="md:col-span-10 md:col-start-3">
              <AtomButton
                class="btn-fill-white w-full !justify-between"
                :to="`/clubs/${$route.params.id}/promo/${promo.slug}`"
                @click.prevent="openPromoModal"
              >
                <span class="-md:text-[12px]">{{ promo.heroTitle }}</span>
                <svg
                  class="-md:w-4"
                  width="50"
                  height="24"
                  viewBox="0 0 50 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M47.863 11.9314L37.0284 1.09679M47.863 11.9314L36.8714 22.923M47.863 11.9314L0.000246264 11.9316"
                    stroke="#282929"
                    stroke-width="2"
                  />
                </svg>
              </AtomButton>
            </div>
          </div>
        </template>
      </OrganismHero>
      <template #footerShort>
        <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] justify-end">
          <div class="flex flex-col flex-1 gap-y-3 md:flex-row gap-x-[10px] md:items-end -md:order-2">
            <AtomButton
              class="self-end -md:order-1 -md:w-full"
              :class="[
                { 'btn btn-white': $route.params.id !== 'encore_yasenevo' },
                { 'btn btn-fill-white': $route.params.id === 'encore_yasenevo' },
              ]"
              @click="modal = 'visit'"
              >ПОСЕТИТЬ КЛУБ</AtomButton
            >
            <AtomButton :to="`/timetable/${club.slug}/adult`" class="btn-white self-end -md:order-1 -md:w-full"
              >РАСПИСАНИЕ</AtomButton
            >
          </div>
          <AtomButton
            v-if="club.youtubeIframe"
            class="-md:!hidden self-end btn-icon btn-lg btn-white"
            @click="modal = 'video'"
          >
            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.68234 12.5438L2.15234 11.6958L2.68234 12.5438ZM10.23 7.82654L9.69996 6.97854L10.23 7.82654ZM10.76 5.28254L3.21234 0.565283L2.15234 2.26128L9.69996 6.97854L10.76 5.28254ZM0.152344 2.26128V11.6958H2.15234V2.26128H0.152344ZM3.21234 13.3918L10.76 8.67454L9.69996 6.97854L2.15234 11.6958L3.21234 13.3918ZM0.152344 11.6958C0.152344 13.2667 1.88024 14.2244 3.21234 13.3918L2.15234 11.6958V11.6958H0.152344ZM3.21234 0.565283C1.88025 -0.267276 0.152344 0.690405 0.152344 2.26128H2.15234L2.15234 2.26128L3.21234 0.565283ZM9.69996 6.97854L9.69996 6.97854L10.76 8.67454C12.0133 7.8912 12.0133 6.06588 10.76 5.28254L9.69996 6.97854Z"
                fill="white"
              />
            </svg>
          </AtomButton>
        </div>
      </template>
    </SectionHero>

    <ModalVisitClub
      v-if="modal === 'visit'"
      :strapi-image-object="club.headerImage || club.image"
      :club-slug="club.slug"
      @close="modal = null"
    />
    <ModalSimpleVideo v-if="modal === 'video'" :iframe-html="club.youtubeIframe" @close="modal = null" />
    <SectionDefault>
      <Builder :blocks="blocks" :context="{ club: club }" />
    </SectionDefault>
  </main>
</template>

<script>
import AtomButton from '../../components/atoms/AtomButton'
import Builder from '../../components/builder/Builder'
import pageBuilder from '../../components/mixins/pageBuilder.js'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'
import ModalSimpleVideo from '../../components/organisms/modals/SimpleVideo'
import ModalVisitClub from '../../components/organisms/modals/VisitClub'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import SectionHero from '../../components/templates/layouts/SectionHero'
import { getUtmList } from '@/utils/cookies'
import { getClubGoalName } from '@/utils/getClubAsYMGoalName'

const mixinPageBuilder = pageBuilder({
  pageUrl: ({ route }) => route.params.id,
})

export default {
  name: 'ClubsId',
  components: {
    AtomButton,
    Builder,
    SectionDefault,
    SectionHero,
    OrganismHero,
    ModalVisitClub,
    ModalSimpleVideo,
  },
  mixins: [mixinPageBuilder],
  data: () => {
    return {
      payload: {
        first_name: '',
        email: '',
        phone: '',
        message: '',
      },
      error: {
        first_name: null,
        email: null,
        phone: null,
        message: null,
        radio: null,
      },
      submitted: false,
      submitting: false,
      successShow: false,
      errorShow: false,
      radio: false,
      modal: null,
    }
  },
  head() {
    if (this.club.slug === 'encore_iset') {
      return {
        script: [
          {
            // calltouch
            type: 'text/javascript',
            charset: 'utf-8',
            innerHTML: `(function(w,d,n,c){w.CalltouchDataObject=n;w[n]=function(){w[n]["callbacks"].push(arguments)};if(!w[n]["callbacks"]){w[n]["callbacks"]=[]}w[n]["loaded"]=false;if(typeof c!=="object"){c=[c]}w[n]["counters"]=c;for(var i=0;i<c.length;i+=1){p(c[i])}function p(cId){var a=d.getElementsByTagName("script")[0],s=d.createElement("script"),i=function(){a.parentNode.insertBefore(s,a)},m=typeof Array.prototype.find === 'function',n=m?"init-min.js":"init.js";s.async=true;s.src="https://mod.calltouch.ru/"+n+"?id="+cId;if(w.opera=="[object Opera]"){d.addEventListener("DOMContentLoaded",i,false)}else{i()}}})(window,document,"ct","b8fkj2zo");`,
          },
          {
            // calltouch-requset
            type: 'text/javascript',
            charset: 'utf-8',
            defer: true,
            innerHTML: `Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function (e) { for (var t = this; t;) { if (t.matches(e)) return t; t = t.parentElement } return null });
            var ct_get_val = function (form, selector) { if (!!form.querySelector(selector)) { return form.querySelector(selector).value; } else { return ''; } }
            window.addEventListener('load', function () {
                var ct_form = document.querySelectorAll('form');
                ct_form.forEach(function (el) { el.addEventListener('submit', function (e) { CalltouchRequest(e); }) });
                function CalltouchRequest(e) {
                    try {
                        var form = e.target;
                        var labels = form.querySelectorAll('label');
                        var fname = Array.from(labels).find((el)=>/имя/i.test(el.innerText))?.parentNode.querySelector('input')?.value;
                        var lname = Array.from(labels).find((el)=>/фамилия/i.test(el.innerText))?.parentNode.querySelector('input')?.value;
                        var fio = [lname, fname].filter((v) => !!v).join(' ');
                        var phoneNumber = ct_get_val(form, '[name="telephone"], [type="tel"]');
                        var email = ct_get_val(form, '[type="email"]');
                        var ct_site_id = 55724;
                        var sub = 'Заявка с ' + location.hostname;
                        var ct_data = {
                            fio: fio,
                            phoneNumber: phoneNumber,
                            email: email,
                            subject: sub,
                            requestUrl: location.href,
                            sessionId: window.call_value
                        };
                        var post_data = Object.keys(ct_data).reduce(function (a, k) { if (!!ct_data[k]) { a.push(k + '=' + encodeURIComponent(ct_data[k])); } return a }, []).join('&');
                        var CT_URL = 'https://api.calltouch.ru/calls-service/RestAPI/requests/' + ct_site_id + '/register/';
                        console.log(ct_data)
                        if (!!phoneNumber) {
                            window.ct_snd_flag = 1; setTimeout(function () { window.ct_snd_flag = 0; }, 20000);
                            var request = window.ActiveXObject ? new ActiveXObject("Microsoft.XMLHTTP") : new XMLHttpRequest();
                            request.open("POST", CT_URL, true); request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                            request.send(post_data);
                        }
                    } catch (e) { console.log(e); }
                }
            })
            `,
          },
        ],

        __dangerouslyDisableSanitizers: ['script'],
      }
    }

    return {}
  },
  computed: {
    club() {
      return this.$store.getters['modules/content/clubs'].find(c => c.slug === this.$route.params.id) || { title: '' }
    },
    promo() {
      return this.club.actions.find(c => c.showLink) || {}
    },
    hero() {
      const title = (this.club.headerTitle || '').split(/\s+/g)
      return {
        variant: 'transparent-parallax',
        imageWrap: 'img-border-0',
        strapiImageObject: this.$device.isDesktop ? this.club.headerImage : this.club.headerImageMobile,
        backgroundVideo: this.club.heroVideo,
        title1: title[0],
        title2: title[1],
        breadcrumbs: this.$breadcrumbs.club({
          clubTitle: capitalize(title[1]),
          clubSlug: this.club.slug,
        }),
      }
      function capitalize(string) {
        if (!string) return ''
        return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1)
      }
    },
  },
  methods: {
    send() {
      this.submitted = true
      if (!this.submitting && this.validateForm()) {
        const phone = `+${this.payload.phone.replace(/[^0-9]/g, '')}`
        let visitorUid = 'unknown'
        try {
          visitorUid = window.AMOPIXEL.getVisitorUid()
        } catch (e) {}
        this.submitting = true

        const utmList = getUtmList(this.$cookies)

        const payload = {
          ...this.payload,
          phone,
          action: this.promo.modalTitle,
          club: this.club.slug,
          visitor_uid: visitorUid,
          ...utmList,
        }

        const sessionId = window?.ct('calltracking_params', 'b4d68ca9')?.sessionId || 0

        if (sessionId) {
          payload.sessionId = sessionId
        }

        let clientId = 0
        try {
          clientId = window?.yaCounter37069155?.getClientID?.() ?? this.$cookies?.get('_ym_uid') ?? 0
        } catch (error) {
          this.$sentry.captureException(error)
        }

        if (clientId) {
          payload.clientId = String(clientId)
        }

        let roistatVisit = 'nocookie'
        try {
          roistatVisit = this.$cookies?.get('roistat_visit') || 'nocookie'
        } catch (error) {
          this.$sentry.captureException(error)
        }

        payload.roistat_visit = String(roistatVisit)

        this.$axios
          .post(
            '/api/forms/action',
            {
              data: payload,
            },
            { __component: `pages/clubs/${this?.club?.slug ?? '_id'}` },
          )
          .then(() => {
            this.successShow = true
            this.sendReachGoal(getClubGoalName(payload.club))
            this.sendReachGoal('success-form-action', {
              api: 'forms/action',
              action: this.promo.modalTitle,
              club: payload.club,
            })
          })
          .catch(e => {
            this.errorShow = true
          })
          .finally(() => {
            this.submitting = false
          })
      }
    },
    validateForm() {
      Object.keys(this.payload).forEach(key => {
        this.validate(key)
      })
      this.error.radio = !this.radio
      return !Object.values(this.error).some(Boolean)
    },
    validate(key) {
      const textIsInvalid = v => !(v || '').trim()
      const schema = {
        first_name: textIsInvalid,
        email: textIsInvalid,
        phone: v => !v || v.length !== 16,
        message: textIsInvalid,
      }
      if (key in this.error && schema[key]) {
        const value = this.payload[key]
        this.error[key] = schema[key](value)
      }
    },
    onInputPhone(value, objValidPhone) {
      this.payload.phone = value

      if (!this.payload.phone || !objValidPhone.isValid) this.error.phone = !objValidPhone.isValid
      else this.error.phone = false
    },
    openPromoModal() {
      const { id = '', heroTitle = '' } = this.promo
      const paramsReq = {
        club: this.club.slug,
        promotion_id: id,
        name: heroTitle,
      }
      this.sendReachGoal('open-promo', paramsReq)
      this.$router.push(`/clubs/${this.$route.params.id}/promo/${this.promo.slug}`)
    },
  },
}
</script>
